import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { fetch } from "./fetch";
import { Booking } from "../app/Bookings/model";

interface Log {
  id: string;
  timestamp: string;
  comment: string;
  userEmail: string;
  userName: string;
  method: string;
  environment: string;
  action: "CREATED" | "UPDATED" | "DELETED";
  entity: string;
}
interface LogsData {
  data: Log[];
  total: number;
}

const getBookingPaymentLogsData = async (paymentId: string): Promise<LogsData> => {
  return fetch(`/api/actions?${new URLSearchParams({ entity: "payment", entityId: paymentId })}`);
};

export const useBookingPaymentLogsDataQuery = (
  paymentId: string,
  bookingId: string,
  options?: Omit<UseQueryOptions<LogsData, Error, LogsData, [string, string]>, "queryKey" | "queryFn">,
) => {
  return useQuery<LogsData, Error, LogsData, [string, string]>({
    queryKey: ["paymentLogsData", paymentId],
    queryFn: () => getBookingPaymentLogsData(paymentId),
    enabled: !!paymentId && !!bookingId && (options?.enabled ?? true),
    ...options,
  });
};
